/**
 * The fields of an AxiosError or AxiosResponse that are safe to log. Request
 * and response headers, bodies, params and the XHR request are never picked,
 * because they carry credentials (HB-Api-Auth-Token) and personal data.
 * Pure: it reads `value` and never changes it.
 */
export function toAxiosLogFields(value) {
    const { config } = value;
    const response = value.response ??
        value;
    return {
        url: config?.url,
        method: config?.method,
        status: response?.status,
        statusText: response?.statusText,
        errorType: response?.data?.error_type,
        errorMessage: response?.data?.error_message,
        errorData: response?.data?.error_data,
        errorNote: response?.data?.note,
        isTimeout: response?.data?.is_timeout,
        msgToUserOnlyOnNonProd: response?.data?.msg_to_user_only_on_non_prod,
        baseURL: config?.baseURL,
        fullRequestUrl: config?.baseURL && config?.url
            ? `${config.baseURL}${config.url}`
            : config?.url
    };
}
export function cleanAxiosError(error) {
    // AxiosError has the config object which has the original request
    // this may hold sensitive data so we want to remove it
    delete error.config;
    delete error.request;
    delete error.response;
}
export function isAxiosResponseAsError(error) {
    // In BaseApiService we might return error.response which is an AxiosResponse
    // AxiosResponse will have the following fields (and a few more) and it's useful to identify it to extract the actual error data
    return (error &&
        typeof error === 'object' &&
        ['data', 'status', 'headers', 'config'].every(attr => attr in error));
}
export const HB_BASE_ERROR_CODES = {
    unauthorized_error: 'HBUnauthorizedError',
    wrong_tos_version_error: 'HBWrongTOSVersionError',
    wrong_api_version_error: 'HBWrongAPIVersionError',
    under_construction_error: 'HBUnderConstructionError',
    object_authorized_error: 'HBObjectUnauthorizedError'
};
//# sourceMappingURL=error.utils.js.map